import { Component, Inject } from '@angular/core';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ButtonVariant, CustomButtonComponent } from '../custom-button/custom-button.component';

export interface ConfirmationDialogData {
  dialogTitle?: string;
  showDialogTitle?: boolean;
  showCloseButton?: boolean;
  dialogMessage: string;
  negativeButtonLabel?: string;
  showNegativeButton?: boolean;
  negativeButtonVariant?: ButtonVariant
  positiveButtonLabel?: string;
  showPositiveButton?: boolean;
  positiveButtonVariant?: ButtonVariant
}

@Component({
  selector: 'app-confirmation-dialog',
  standalone: true,
  imports: [MatDialogModule, MatIconModule, MatButtonModule, CustomButtonComponent],
  templateUrl: './confirmation-dialog.component.html',
  styleUrl: './confirmation-dialog.component.scss'
})
export class ConfirmationDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData
  ) {
    // Set default values
    this.data = {
      dialogTitle: data.dialogTitle || '',
      showDialogTitle: data.showDialogTitle !== false,
      showCloseButton: data.showCloseButton !== false,
      dialogMessage: data.dialogMessage,
      negativeButtonLabel: data.negativeButtonLabel || 'Cancel',
      showNegativeButton: data.showNegativeButton || false,
      negativeButtonVariant: data.negativeButtonVariant || 'text-underline',
      positiveButtonLabel: data.positiveButtonLabel || 'Ok',
      showPositiveButton: data.showPositiveButton || false,
      positiveButtonVariant: data.positiveButtonVariant || 'primary'
    };
  }

  onClose(): void {
    this.dialogRef.close(false);
  }

  onNegative(): void {
    this.dialogRef.close(false);
  }

  onPositive(): void {
    this.dialogRef.close(true);
  }
}